import React from 'react';
import './styles.scss';

export default () => (
  <div className="loading-page container">
    <div className="loader" />
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/pageLoading/PageLoading.js